import { getQueryFromUrl } from "@utils/helpers/getQueryFromUrl";

import ContentComponentSelector from "@modules/content/components";
import { db } from "@modules/local/db";
import { useAppLiveQuery } from "@modules/local/hooks";

import { RamadanBackground } from "../ramadan/RamadanPage";

export const Component = () => {
  const type = getQueryFromUrl("type");
  const id = getQueryFromUrl("id");

  const { result: componentData } = useAppLiveQuery(
    () => db.components.get(id!),
    [id]
  );

  return (
    <div className="relative h-full w-full">
      <RamadanBackground />
      <h1 className="mt-[20px] px-10 pb-[60px] text-right text-[44px] font-bold text-black dark:text-dark-ramadan-primary">
        {componentData?.referenceName}
      </h1>
      <ContentComponentSelector
        identifier={type?.replaceAll("-", ":").toUpperCase() || ""}
        id={id || ""}
        componentRef={null}
      />
    </div>
  );
};
